<template>
    <MainContainer>
        <template v-slot:sidebar>&nbsp;</template>
        <div class="anwesenheitsstatisik">
            <h2>Anwesenheitsstatisik</h2>
            <section class="charts">
                <h5>
                    Auswertungen
                    <b-button v-b-toggle.charts size="sm">Einblenden/Ausblenden</b-button>
                </h5>
                <b-collapse id="charts" visible>
                    <template v-if="busy">
                        <CenteredMessage :spinner="true">
                            <template #title>Auswertungen werden generiert</template>
                        </CenteredMessage>
                    </template>
                    <template v-else>
                        <b-row>
                            <b-col cols="12">
                                <h6 class="text-center">MV Sänger zu Gastsängern</h6>
                                <LineChart
                                    v-if="charts.werke.loaded"
                                    :chartdata="charts.werke.chartData"
                                />
                            </b-col>
                            <b-col cols="12">
                                <h6 class="text-center">Teilnhemende Sänger zu allen MV Sängern</h6>
                                <LineChart
                                    v-if="charts.werkeMV.loaded"
                                    :chartdata="charts.werkeMV.chartData"
                                />
                            </b-col>
                        </b-row>
                    </template>
                </b-collapse>
            </section>
            <!--<section>
                <b-form>
                    <b-form-group label="Stimme" label-for="singer" :label-size="size">
                        <b-select
                            id="singer"
                            :size="size"
                            :options="voice.options"
                            v-model="filter.voice"
                        ></b-select>
                    </b-form-group>
                    <b-button :size="size" @click="selectFilter" variant="primary">Anzeigen</b-button>
                    <b-button
                        :size="size"
                        @click="resetFilter"
                        class="ml-1"
                        variant="outline-danger"
                    >Zurücksetzen</b-button>
                </b-form>
            </section>-->
            <!--<hr />-->
            <hr />
            <section class="information">
                <h5>Informationen</h5>
                <Table
                    :responsive="true"
                    striped
                    bordered
                    showFilter
                    emptyText="Keine Anwesenheitsdaten vorhanden"
                    busyText="Anwesenheitsstatisik wird geladen..."
                    :isBusy="busy"
                    :fields="fields"
                    :items="items"
                >
                    <template v-slot:verfallsdatum="{ row: row }">
                        {{
                        $moment(row.value).format("DD.MM.Y")
                        }}
                    </template>

                    <template v-slot:share="{ row: row }">
                        <b>{{ row.value }}%</b>
                    </template>
                </Table>
            </section>
        </div>
    </MainContainer>
</template>

<script>
import Size from "@/mixins/Size/Size";
import CommonView from "@/mixins/CommonView/CommonView";
import { ApiFactory } from "@/api/ApiFactory.js";
import MainContainer from "@/components/MainContainer/MainContainer";
import Table from "@/components/Table/Table";
import LineChart from "@/components/LineChart/LineChart";
import CenteredMessage from "@/components/CenteredMessage/CenteredMessage";

const AnwesenheitsverwaltungApi = ApiFactory.get("anwesenheitsverwaltung");

export default {
    name: "AnwesenheitsverwaltungNeu",
    mixins: [CommonView, Size],
    components: {
        MainContainer,
        Table,
        LineChart,
        CenteredMessage
    },
    data() {
        return {
            api: AnwesenheitsverwaltungApi,
            filter: {
                voice: null
            },
            voice: {
                options: [
                    {
                        value: null,
                        text: "Alle Stimmen"
                    },
                    {
                        value: "sopran",
                        text: "Sopran"
                    },
                    {
                        value: "alt",
                        text: "Alt"
                    },
                    {
                        value: "tenor",
                        text: "Tenor"
                    },
                    {
                        value: "bass",
                        text: "Bass"
                    }
                ]
            },
            fields: [
                {
                    key: "id",
                    label: "ID",
                    sortable: true
                },
                {
                    key: "bezeichnung",
                    label: "Werk",
                    sortable: true
                },
                {
                    key: "verfallsdatum",
                    label: "Datum",
                    sortable: true
                },
                {
                    key: "hosts",
                    label: "Anzahl Sänger MV",
                    sortable: false,
                    variant: "success",
                    class: "text-right"
                },
                {
                    key: "share_hosts",
                    label: "Anteil teiln. MV Sänger zu allen MV Sängern in %",
                    sortable: false,
                    variant: "secondary",
                    class: "text-right"
                },
                {
                    key: "guests",
                    label: "Anzahl Gastsänger",
                    sortable: false,
                    variant: "danger",
                    class: "text-right"
                },
                {
                    key: "share_guests",
                    label: "Anteil Gastsänger in %",
                    sortable: false,
                    class: "text-right"
                }
            ],
            charts: {
                werke: {
                    loaded: false,
                    chartData: {}
                },
                werkeMV: {
                    loaded: false,
                    chartData: {}
                }
            }
        };
    },
    methods: {
        async fetch() {
            this.busy = true;
            const response = await this.api.getEvaluation();
            if (response.ok) {
                const items = response.json;
                this.items = items.werke;

                this.processWerkeChart([...items.werke]);
                this.processWerkeMVChart([...items.werke]);
            }
            this.busy = false;
        },
        processWerkeChart(items) {
            items = items.reverse();

            var chartData = {
                labels: [],
                datasets: []
            };

            var datasetHosts = {
                data: [],
                label: "Mitglieder",
                borderColor: "rgba(177, 223, 187, 1)",
                backgroundColor: "rgba(177, 223, 187, 0.5)",
                fill: true
            };
            var datasetGuests = {
                data: [],
                label: "Gastsänger",
                borderColor: "rgba(245, 198, 203, 1)",
                backgroundColor: "rgba(245, 198, 203, 0.75)",
                fill: true
            };
            for (const item of items) {
                chartData.labels.push(item.bezeichnung);
                datasetHosts.data.push(item.hosts);
                datasetGuests.data.push(item.guests);
            }
            chartData.datasets.push(datasetHosts, datasetGuests);

            this.charts.werke.chartData = chartData;
            this.charts.werke.loaded = !this.charts.werke.loaded;
        },
        processWerkeMVChart(items) {
            items = items.reverse();

            var chartData = {
                labels: [],
                datasets: []
            };

            var datasetHosts = {
                data: [],
                label: "teilnehmende Mitglieder",
                borderColor: "rgba(177, 223, 187, 1)",
                backgroundColor: "rgba(177, 223, 187, 0.5)",
                fill: true
            };
            var datasetHostsTotal = {
                data: [],
                label: "Mitglieder gesamt",
                borderColor: "rgba(214, 216, 219, 0.75)",
                backgroundColor: "rgba(214, 216, 219, 1)",
                fill: false
            };
            for (const item of items) {
                chartData.labels.push(item.bezeichnung);
                datasetHosts.data.push(item.hosts);
                datasetHostsTotal.data.push(item.hosts_total);
            }
            chartData.datasets.push(datasetHosts, datasetHostsTotal);

            this.charts.werkeMV.chartData = chartData;
            this.charts.werkeMV.loaded = !this.charts.werkeMV.loaded;
        },
        selectFilter() {
            this.fetch();
        },
        resetFilter() {
            const filter = {
                voice: null
            };
            this.filter = filter;
        }
    }
};
</script>
